import React from "react";
import Customize3d from "../../components/Customize3d/Customize3D";

const CustomizePage = () => {
    return (
        <div className={`p-3 flex w-full flex-col wow animate__animated animate__fadeIn`}>
            <Customize3d />
        </div>
    );
};

export default CustomizePage;
